import { render, staticRenderFns } from "./HeartIcon32px.vue?vue&type=template&id=55a1144c&"
import script from "./HeartIcon32px.vue?vue&type=script&lang=js&"
export * from "./HeartIcon32px.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports